// Application global objects
//
window.BIDS = window.BIDS || {};

BIDS.api = {};
